(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bbr-uk-v2"] && !Shopify.designMode) return;
  try {
    
function setupBBRComparatorV2(){
const root=document.getElementById('bbr-uk-v2');if(!root||root.dataset.ready)return;root.dataset.ready='true';
const toggle=root.querySelector('[aria-controls="bbr-v2-mobile-nav"]');if(toggle)toggle.addEventListener('click',()=>{let menu=root.querySelector('#bbr-v2-mobile-nav');if(!menu){menu=document.createElement('nav');menu.id='bbr-v2-mobile-nav';const nav=root.querySelector('nav[aria-label="Main"]');if(nav)menu.innerHTML=nav.innerHTML;root.querySelector('header').append(menu);}const expanded=toggle.getAttribute('aria-expanded')==='true';toggle.setAttribute('aria-expanded',String(!expanded));menu.hidden=expanded;});
const bar=root.querySelector('.tc-sticky');if(bar){let pending=false;const update=()=>{const show=window.scrollY>800;bar.classList.toggle('translate-y-full',!show);bar.setAttribute('aria-hidden',String(!show));pending=false;};window.addEventListener('scroll',()=>{if(!pending){pending=true;requestAnimationFrame(update);}},{passive:true});update();}
}
setupBBRComparatorV2();document.addEventListener('shopify:section:load',setupBBRComparatorV2);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bbr-us-v2"] && !Shopify.designMode) return;
  try {
    
function setupBBRComparatorUSV2(){
const root=document.getElementById('bbr-us-v2');if(!root||root.dataset.ready)return;root.dataset.ready='true';
const toggle=root.querySelector('[aria-controls="bbr-us-v2-mobile-nav"]');if(toggle)toggle.addEventListener('click',()=>{let menu=root.querySelector('#bbr-us-v2-mobile-nav');if(!menu){menu=document.createElement('nav');menu.id='bbr-us-v2-mobile-nav';const nav=root.querySelector('nav[aria-label="Main"]');if(nav)menu.innerHTML=nav.innerHTML;root.querySelector('header').append(menu);}const expanded=toggle.getAttribute('aria-expanded')==='true';toggle.setAttribute('aria-expanded',String(!expanded));menu.hidden=expanded;});
const bar=root.querySelector('.tc-sticky');if(bar){let pending=false;const update=()=>{const show=window.scrollY>800;bar.classList.toggle('translate-y-full',!show);bar.setAttribute('aria-hidden',String(!show));pending=false;};window.addEventListener('scroll',()=>{if(!pending){pending=true;requestAnimationFrame(update);}},{passive:true});update();}
}
setupBBRComparatorUSV2();document.addEventListener('shopify:section:load',setupBBRComparatorUSV2);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tc-exact-uk"] && !Shopify.designMode) return;
  try {
    
function setupExactComparator(){
const root=document.getElementById('tc-exact-uk');if(!root||root.dataset.ready)return;root.dataset.ready='true';
const toggle=root.querySelector('[aria-controls="tc-mobile-nav"]');if(toggle)toggle.addEventListener('click',()=>{let menu=root.querySelector('#tc-mobile-nav');if(!menu){menu=document.createElement('nav');menu.id='tc-mobile-nav';const nav=root.querySelector('nav[aria-label="Main"]');if(nav)menu.innerHTML=nav.innerHTML;root.querySelector('header').append(menu);}const expanded=toggle.getAttribute('aria-expanded')==='true';toggle.setAttribute('aria-expanded',String(!expanded));menu.hidden=expanded;});
const bar=root.querySelector('.tc-sticky');if(bar){let pending=false;const update=()=>{const show=window.scrollY>800;bar.classList.toggle('translate-y-full',!show);bar.setAttribute('aria-hidden',String(!show));pending=false;};window.addEventListener('scroll',()=>{if(!pending){pending=true;requestAnimationFrame(update);}},{passive:true});update();}
}
setupExactComparator();document.addEventListener('shopify:section:load',setupExactComparator);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tc-exact-us"] && !Shopify.designMode) return;
  try {
    
function setupExactComparator(){
const root=document.getElementById('tc-exact-us');if(!root||root.dataset.ready)return;root.dataset.ready='true';
const toggle=root.querySelector('[aria-controls="tc-mobile-nav"]');if(toggle)toggle.addEventListener('click',()=>{let menu=root.querySelector('#tc-mobile-nav');if(!menu){menu=document.createElement('nav');menu.id='tc-mobile-nav';const nav=root.querySelector('nav[aria-label="Main"]');if(nav)menu.innerHTML=nav.innerHTML;root.querySelector('header').append(menu);}const expanded=toggle.getAttribute('aria-expanded')==='true';toggle.setAttribute('aria-expanded',String(!expanded));menu.hidden=expanded;});
const bar=root.querySelector('.tc-sticky');if(bar){let pending=false;const update=()=>{const show=window.scrollY>800;bar.classList.toggle('translate-y-full',!show);bar.setAttribute('aria-hidden',String(!show));pending=false;};window.addEventListener('scroll',()=>{if(!pending){pending=true;requestAnimationFrame(update);}},{passive:true});update();}
}
setupExactComparator();document.addEventListener('shopify:section:load',setupExactComparator);

  } catch(e) { console.error(e); }
})();
})();
